import { render, staticRenderFns } from "./LogsTab.vue?vue&type=template&id=9c27d202"
import script from "./LogsTab.vue?vue&type=script&lang=js"
export * from "./LogsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports